export const QUEUE_ROOT = "filas-caze-rj-sp";

export const QUEUE_STATUS_MESSAGES = {
  ativa: "",
  fechada: "Essa fila não está aceitando novas participações.",
  inativa: "Esta fila está fechada. No momento, não é possível entrar nela.",
  pausada:
    "A fila está temporariamente pausada, mas voltará em breve. Se você já estava na fila, não se preocupe: sua posição está garantida e será mantida assim que o sistema for retomado.",
} as const;
